import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="container" style={{ textAlign: "center", padding: "80px 16px" }}>
      <h1 style={{ fontSize: 48, margin: 0 }}>404</h1>
      <p className="muted">That page doesn't exist on Pop Market.</p>
      <Link to="/">Back to browse</Link>
    </div>
  );
}
